import React from "react";
import { Dialog, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function EventTimerFullscreen(props) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.countdownTimer"
  });

  const { open, setOpen, message1, message2, color, animate } = props;

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        "& .MuiPaper-root": {
          alignItems: "center",
          justifyContent: "center"
        }
      }}
      onClick={() => setOpen(false)}
    >
      <Typography
        variant="h1"
        sx={{
          color: color,
          animation: animate ? "blinker 1s linear infinite" : "",
          fontSize: message1.trim() === t("eventBeginsIn") ? "18vw" : "22vw",
          "@keyframes blinker": {
            "50%": {
              opacity: 0
            }
          }
        }}
      >
        {message1}
      </Typography>
      <Typography
        variant="h1"
        sx={{
          color: color,
          animation: animate ? "blinker 1s linear infinite" : "",
          fontSize: message2.trim() === t("noTimeRemaining") ? "9vw" : "15vw",
          "@keyframes blinker": {
            "50%": {
              opacity: 0
            }
          }
        }}
      >
        {message2.trim()}
      </Typography>
    </Dialog>
  );
}
